const kilo = 1024;

const Kb = file => file.size / kilo;
const Mb = file => Kb(file) / kilo;

export default { Kb, Mb };
